export const NIKE_EASE = [0.4, 0, 0, 1];
export const NIKE_EASE_CSS = `cubic-bezier(${NIKE_EASE.join()})`;
export const ANIMATION_DURATION_S = 1;
export const ANIMATION_DURATION_MS = ANIMATION_DURATION_S * 1000;
